import CollectionCard from '../../components/CollectionCard/CollectionCard';
import { useState } from 'react';
import { collections } from '../../data/collections';
import { Navigate, useParams } from 'react-router-dom';


const categories = {
    art: {name: "Art"},
    domainnames: {name: "Domain Names"},
    photography: {name: "Photography"},
    virtualworlds: {name: "Virtual Worlds"},
    sports: {name: "Sports"},
    collectibles: {name: "Collectibles"},
    music: {name: "Music"},
    tradingcards: {name: "Trading Cards"},
    utility: {name: "Utility"},
}

const Category = () => {
    
    const {id} = useParams();
    const [show, setShow] = useState(false);

    if(categories[id] === undefined){
        return <Navigate to = '/collections' />
    }

    else{
    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20"> 
            
                <div className="mb-[84px] w-full h-[220px] max-h-full max-w-full overflow-hidden flex justify-center items-center relative collection_cover">
                    <img src = 'https://images.unsplash.com/photo-1499781350541-7783f6c6a0c8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1545&q=80' 
                        alt = 'collectibles banner' className="h-full w-full object-cover" />
                </div>
                <div className='flex flex-col items-center justify-center mb-[20px]'>
                    <h1 className='text-3xl lg:text-4xl font-[600] leading-60px text-center mb-[35px]'>Explore {categories[id].name}</h1>
                    <div className={`transition_0-1s overflow-hidden ${show ? 'max-h-[1000px] mb-10' : 'max-h-[110px] text_gray_mask mb-2'}`} >
                        <p className='text-base 2xl:text-lg leading-[27px] text-center max-w-[78ch] mb-[35px] text-gray-500'>
                                An online community of makers, developers, and traders is pushing the art world into new territory. 
                                It all started with CryptoPunks, a set of 10,000 randomly generated punks that proved demand for
                                the digital ownership of non-physical items and collectibles in 2017,
                                and the market has evolved rapidly ever since.
                        </p>
                        <p className='text-base 2xl:text-lg leading-[27px] text-center max-w-[78ch] text-gray-500'>
                            As the underlying technology develops, a growing pool of artists are selling verified, immutable works to art lovers
                            and speculators, and the space as a whole is waking up to the power and potential of decentralized networks and
                            currencies. With creators and collectors generating meaningful revenue through an entirely digital ecosystem,
                            the tokenization of gifs, memes, and MP4s is emerging as the most exciting and relevant blockchain use case.
                            From SuperRare to Josie to JOY, browse and trade NFTs from some of the world's top crypto artists on Digirack.
                        </p>   
                    </div>  
                    <div className="flex justify-center">
                        {!show ? (
                            <button onClick={()=>setShow(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[16px]' viewBox="0 0 320 512">
                                    <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"/>
                                </svg>
                            </button>
                        ):(
                            <button onClick={()=>setShow(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[16px]' viewBox="0 0 320 512">
                                    <path d="M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"/>
                                </svg>
                            </button>
                        )}
                        
                        
                    </div>
                     
                </div>

         

            <div className="border-t-[1px] border-gray-700">
                <div className="lg:container mx-auto px-4">
                    <h1 className='text-[20px] lg:text-[24px] font-[600] text-center py-8 my-3'>Trending Collections in {categories[id].name}</h1>
                </div>
            </div>

            <div className='mb-16 md:mb-32'> 
               
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 xl:gap-10">
                {/* <div className="flex justify-center flex-wrap"> */}
                    {collections.map((item) => {
                        return(
                            <CollectionCard item={item}/>
                        )
                    })}
                </div>

                <div className="w-full flex justify-center">
                    
                </div>

            </div>
            
                    

        </div>
    )
    }
}

export default Category;